import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';
import { Observable, map } from 'rxjs';

@Injectable()
export class PingService {
  constructor(private httpClient: HttpClient) {}

  tenantIsConnected(): Observable<boolean> {
    const route = `${environment.examInfoBackend}/tenant_online`;
    return this.httpClient.get<any>(route).pipe(
      map((r) => {
        if (r?.status === 'online') {
          return true;
        }
        return false;
      }),
    );
  }
}
